import { defineMessages } from "react-intl";
const messages = defineMessages({
    selectProperty: {
        id: "app.multiple.property.selector.text",
        defaultMessage: "Community",
    },
    selectPropertyPlaceholder: {
        id: "app.multiple.property.selector.placeholder.text",
        defaultMessage: "Select specific communities",
    },
    selectAll: {
        id: "app.multiple.property.selector.select.all.text",
        defaultMessage: "Select All",
    },
    clearSelection: {
        id: "app.multiple.property.selector.clear.selection.text",
        defaultMessage: "Clear selection",
    },
});
export default messages;
